import { IridiumVar } from '@/api/userAccount';
import { IridiumServiceUiOptions, uiOptionsPerIridiumVar } from '@/config';

/*
    We are working on breaking up accounts with multiple iridium vars but there are still some
    This is to make sure we can show/hide UI elements based on the iridium var even if the account has multiple

    TODO: multiple iridium vars support
    Remove this when we are sure all accounts have only one iridium var
    and replace with a simple uiOptionsPerIridiumVar[accountIridiumVar].usesSatelliteCredits
 */
export const showUiElementPerIridiumVar = (
    accountIridiumVar: IridiumVar | null | undefined,
    property: keyof IridiumServiceUiOptions,
    matchingMethod: 'some' | 'every' = 'some'
) => {
    if (!accountIridiumVar) {
        return false;
    }
    return Object.entries(uiOptionsPerIridiumVar)
        .filter(([key]) => accountIridiumVar.includes(key))
        [matchingMethod](([_, value]) => value[property]);
};
